import React, { createContext, useContext, useState, useMemo } from "react";

type LoanType = string;

const LoanTypeContext = createContext<{
  loanType: LoanType;
  setLoanType: (type: LoanType) => void;
}>({
  loanType: "COSUMER_LOAN",
  setLoanType: () => {},
});

export const LoanTypeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loanType, setLoanType] = useState<LoanType>("COSUMER_LOAN");

  // ✅ Memoize để không bị ESLint warning
  const contextValue = useMemo(() => ({ loanType, setLoanType }), [loanType]);

  return (
    <LoanTypeContext.Provider value={contextValue}>
      {children}
    </LoanTypeContext.Provider>
  );
};

export const useLoanType = () => useContext(LoanTypeContext);
